import CoreInputTextRight from "./CoreInputTextRight";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Right", CoreInputTextRight);
